import { render, staticRenderFns } from "./TcmRx2.vue?vue&type=template&id=57fb812e&scoped=true"
import script from "./TcmRx2.vue?vue&type=script&lang=js"
export * from "./TcmRx2.vue?vue&type=script&lang=js"
import style0 from "./TcmRx2.vue?vue&type=style&index=0&id=57fb812e&scoped=true&lang=css"
import style1 from "./TcmRx2.vue?vue&type=style&index=1&id=57fb812e&lang=scss&scoped=true"
import style2 from "./TcmRx2.vue?vue&type=style&index=2&id=57fb812e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fb812e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57fb812e')) {
      api.createRecord('57fb812e', component.options)
    } else {
      api.reload('57fb812e', component.options)
    }
    module.hot.accept("./TcmRx2.vue?vue&type=template&id=57fb812e&scoped=true", function () {
      api.rerender('57fb812e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TCMRx/TcmRx2.vue"
export default component.exports